import React from 'react';
import plusIcon from '../../../assets/img/event-imgs/e-plus.svg';
import blogImage from '../../../assets/img/blog-imgs/blog-image1.png';
import userPicture from '../../../assets/img/blog-imgs/blog-userpic1.svg';
import starIcon from '../../../assets/img/gigs-imgs/star.svg';

const ProductDetails = () => {
    const shopFakeDatas = [
        {
            productThumbnail: blogImage,
            videoTime : "10:26",
            productShortDescription: "In pulvinar libero eu puru vehicula, et...",
            authorImage: userPicture,
            authorName: "Ema Richard",
            ratingStar: 4.3,
            peopleStarGiven: 254,
            realAmount: 129,
            afterDiscount: 59
        },
        {
            productThumbnail: blogImage,
            videoTime : "10:26",
            productShortDescription: "In pulvinar libero eu puru vehicula, et...",
            authorImage: userPicture,
            authorName: "Ema Richard",
            ratingStar: 4.3,
            peopleStarGiven: 254,
            realAmount: 129,
            afterDiscount: 59
        },
        {
            productThumbnail: blogImage,
            videoTime : "10:26",
            productShortDescription: "In pulvinar libero eu puru vehicula, et...",
            authorImage: userPicture,
            authorName: "Ema Richard",
            ratingStar: 4.3,
            peopleStarGiven: 254,
            realAmount: 129,
            afterDiscount: 59
        },
        {
            productThumbnail: blogImage,
            videoTime : "10:26",
            productShortDescription: "In pulvinar libero eu puru vehicula, et...",
            authorImage: userPicture,
            authorName: "Ema Richard",
            ratingStar: 4.3,
            peopleStarGiven: 254,
            realAmount: 129,
            afterDiscount: 59
        },
        {
            productThumbnail: blogImage,
            videoTime : "10:26",
            productShortDescription: "In pulvinar libero eu puru vehicula, et...",
            authorImage: userPicture,
            authorName: "Ema Richard",
            ratingStar: 4.3,
            peopleStarGiven: 254,
            realAmount: 129,
            afterDiscount: 59
        },
        {
            productThumbnail: blogImage,
            videoTime : "10:26",
            productShortDescription: "In pulvinar libero eu puru vehicula, et...",
            authorImage: userPicture,
            authorName: "Ema Richard",
            ratingStar: 4.3,
            peopleStarGiven: 254,
            realAmount: 129,
            afterDiscount: 59
        },
        {
            productThumbnail: blogImage,
            videoTime : "10:26",
            productShortDescription: "In pulvinar libero eu puru vehicula, et...",
            authorImage: userPicture,
            authorName: "Ema Richard",
            ratingStar: 4.3,
            peopleStarGiven: 254,
            realAmount: 129,
            afterDiscount: 59
        },
        {
            productThumbnail: blogImage,
            videoTime : "10:26",
            productShortDescription: "In pulvinar libero eu puru vehicula, et...",
            authorImage: userPicture,
            authorName: "Ema Richard",
            ratingStar: 4.3,
            peopleStarGiven: 254,
            realAmount: 129,
            afterDiscount: 59
        },
    ]
    return (
       <div className='row gy-4'>
           {
               shopFakeDatas.map(( item, index ) => <div className="col-12 col-md-6 col-xxl-4" key={index}>
                    <div className="card" style={{backgroundColor: "#171717", borderRadius: "20px",borderStyle: "none"}}>
                        <div className="position-relative">
                            <button className="btn btn-primary position-absolute rounded-circle d-flex justify-content-center align-items-center p-1" type="button" style={{backgroundColor:" #00000041",borderStyle: "none",right: "4%",bottom: "4%"}}>
                                <img src={plusIcon} alt='' />
                            </button>
                            <img className="w-100" src={blogImage} style={{borderRadius: "20px 20px 0px 0px"}} alt='' />
                            <div className="position-absolute px-2 rounded-pill d-flex justify-content-center align-items-center gap-1 l_wbadge">
                                <span className="c_time">10:26</span>
                            </div>
                        </div>

                        <div className="w-100" style={{height: "4px",background: "linear-gradient(90deg, #B402F6, #40EEFE)" }}></div>
                        <div className="card-body">
                            <div className="row gap-2">
                                <div className="col-12">
                                    <span className="txt_wa">In pulvinar libero eu puru vehicula, et...</span>
                                </div>
                                <div className="col-12">
                                    <img className="me-1" src={userPicture} alt="" />
                                    <span className="txt_name">Ema Richard</span>
                                </div>
                            </div>
                        </div>

                        <div className="w-100" style={{height: "1px",background: "#3E3E3E"}}></div>
                        <div className="card-body">
                            <div className="row gap-2">
                                <div className="col-12 d-flex justify-content-between align-items-center">
                                    <div className="d-flex justify-content-center align-items-center gap-1">
                                        <img src={starIcon} alt="" />
                                        <span className="b_dt">4.3</span><span className="s_ur">(254)</span>
                                    </div>
                                    <div className="d-flex justify-content-end align-items-center gap-1">
                                        <span className="s_op">$129</span>
                                        <span className="txt_wa">$59.00</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               )
           }
       </div>
    );
};

export default ProductDetails;